'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  byTrackId: ImmutableMap(),
  byLessonId: ImmutableMap(),
  errorsByTrackId: ImmutableMap(),
  errorsByLessonId: ImmutableMap(),
  requestingByTrackId: ImmutableMap(),
  requestingByLessonId: ImmutableMap()
});
export default function ACAD018(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_REQUESTING:
      return state.setIn(['errorsByTrackId', action.meta.id], false).setIn(['requestingByTrackId', action.meta.id], true);
    case ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_RECEIVED:
      return state.setIn(['byTrackId', action.meta.id], List(action.payload)).setIn(['errorsByTrackId', action.meta.id], false).setIn(['requestingByTrackId', action.meta.id], false);
    case ActionTypes.AVAILABLE_LANGUAGES_BY_TRACK_ID_ERROR:
      return state.setIn(['byTrackId', action.meta.id], undefined).setIn(['errorsByTrackId', action.meta.id], true).setIn(['requestingByTrackId', action.meta.id], false);
    case ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_REQUESTING:
      return state.setIn(['errorsByLessonId', action.meta.id], false).setIn(['requestingByLessonId', action.meta.id], true);
    case ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_RECEIVED:
      return state.setIn(['byLessonId', action.meta.id], List(action.payload)).setIn(['errorsByLessonId', action.meta.id], false).setIn(['requestingByLessonId', action.meta.id], false);
    case ActionTypes.AVAILABLE_LANGUAGES_BY_LESSON_ID_ERROR:
      return state.setIn(['byLessonId', action.meta.id], undefined).setIn(['errorsByLessonId', action.meta.id], true).setIn(['requestingByLessonId', action.meta.id], false);
    default:
      return state;
  }
}